import { render, staticRenderFns } from "./TaskGroupEditModal.vue?vue&type=template&id=495186f2&"
import script from "./TaskGroupEditModal.vue?vue&type=script&lang=ts&"
export * from "./TaskGroupEditModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports